<h2 mat-dialog-title>Details</h2>

<mat-dialog-content class="mat-typography">


  <table #table *ngIf="dataSource" [dataSource]="dataSource" class="mat-elevation-z0 w-100" mat-table>


    <ng-container matColumnDef="field">
      <th *matHeaderCellDef [ngClass]="'w-35'" mat-header-cell>Field</th>
      <td *matCellDef="let element" [ngClass]="'w-35'" mat-cell> {{element.field | splitCamelCase}} </td>
    </ng-container>

    <ng-container matColumnDef="value">
      <th *matHeaderCellDef [ngClass]="'w-65'" mat-header-cell>Value</th>
      <td *matCellDef="let element" [ngClass]="'w-65'" mat-cell>
        <div *ngIf="element.value != undefined">{{element.value}}</div>
        <mat-progress-bar mode="indeterminate" *ngIf="element.value === undefined"></mat-progress-bar>
      </td>
    </ng-container>

    <tr *matHeaderRowDef="['field', 'value']" mat-header-row></tr>
    <tr *matRowDef="let row; columns:  ['field', 'value'];" mat-row></tr>

  </table>


</mat-dialog-content>
<ng-container *ngIf="!disableCloseButton">
  <mat-dialog-actions fxLayoutAlign="end">
    <button *ngIf="expandUrl" mat-button (click)="openExpandUrl()">MORE DETAILS</button>
    <button mat-button matDialogClose>CLOSE</button>
  </mat-dialog-actions>
</ng-container>